import { useContext, useEffect, useState } from 'react'

import { Box, Button, Icon, Text } from '@fairfashion/design-system'

import { CreateProductModal } from '../ProductDetails/components/CreateProductModal/create-product-modal.comp'

import { ProductsTable } from './components/ProductsTable/products-table.comp'
import { ProductsContext, ProductsProvider } from './products.context'
import * as Styles from './products.styles'

const ProductsComp = () => {
  const [createProductModalOpen, setCreateProductModalOpen] = useState(false)

  const { actions, dashboardData } = useContext(ProductsContext)

  useEffect(() => {
    actions.getDashboardData()
  }, [])

  return (
    <Box width="100%" height="100%" padding={3} direction="column" gap={3}>
      <Box justifyContent="space-between" width="100%">
        <Text>Produtos</Text>
        <Button onClick={() => setCreateProductModalOpen(true)}>
          <Box gap={1} alignItems="center">
            <Text color="white" fontWeight={500}>
              Criar novo produto
            </Text>
            <Icon name="add" size={20} color="white" />
          </Box>
        </Button>
      </Box>
      <Box width="100%" gap={3} direction="column" paddingBottom={3}>
        <Box width="100%" gap={3} flexWrap="wrap" alignItems="stretch">
          <Styles.Card
            title="Produtos produzidos"
            icon="price_tag3"
            value={dashboardData?.finishedItemsQuantityPropSum?.value ?? 0}
            color="purple"
          />
          <Styles.Card
            title="Quantidade de produtos rastreados"
            icon="map_pin5"
            value={
              dashboardData?.finishedItemsTracedToEndSupplierQuantityPropSum
                ?.value ?? 0
            }
            color="lilac"
          />
          <Styles.Card
            title="Produtos rastreados"
            icon="percent"
            value={
              dashboardData
                ?.finishedItemsTracedToEndSupplierQuantityPropPercentage
                ?.value ?? 0
            }
            color="light_blue"
          />
        </Box>
        <Box width="100%">
          <ProductsTable />
        </Box>
      </Box>
      <CreateProductModal
        open={createProductModalOpen}
        onClose={() => setCreateProductModalOpen(false)}
      />
    </Box>
  )
}

export const Products = () => {
  return (
    <ProductsProvider>
      <ProductsComp />
    </ProductsProvider>
  )
}
